export enum KeyboardsEnums {
  Backspace = 'Backspace',
  Delete = 'Delete',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
}
